import { WsError } from './WsTypes';
import { setToken } from '../services/userService';

export function unwrap<T>(value: T | null | undefined): T {
  if (!value) {
    throw new Error('Unwrapping not possible because the variable is null or undefined!');
  }
  return value; // at this point Flow should understand it cannot be of type Optional or Maybe
}

export const errorObject: WsError = {
  errorCode: 'INTERNAL_ERROR',
  statusArguments: [],
};

export const errorServerConnection: WsError = {
  errorCode: 'SERVER_CONNECTION',
  statusArguments: [],
};

export function rawResponseCatcher(response: Response): Promise<WsError> {
  // eslint-disable-next-line
  console.log('Cannot connect to HTTP server', response);
  throw Promise.resolve(errorServerConnection);
}

export function responseCatcher(response: Response, producedType: string): Response {
  const contentType = response.headers.get('content-type');
  if (
    response.body && producedType
    && (!contentType || contentType.indexOf(producedType) === -1)
  ) {
    // eslint-disable-next-line
    console.log('Response type is not json', response);
    throw Promise.resolve(errorObject);
  }
  return response;
}

// eslint-disable-next-line
export function toJsonError(response: any) {
  if (typeof response.then === 'function') {
    throw response;
  }
  const contentType = response.headers.get('content-type');
  if (!contentType || contentType.indexOf('application/json') === -1) {
    // eslint-disable-next-line
    console.log('Response type is not JSON', response);
    throw errorObject;
  }
  throw response.json();
}

// eslint-disable-next-line
export default function handleError(response: any) {
  if (response.status === 403) {
    throw Promise.resolve({
      errorCode: 'AUTHENTIFICATION_EXPIRED',
      statusArguments: [],
    });
  }
  if (response.status === 401) {
    setToken(null);
    window.location.reload();
  }
  if (!response.ok) {
    throw response;
  }
  return response;
}
